import React, { Component } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ListItem from "@material-ui/core/ListItem";

import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import SectionBody from "../SectionBody/SectionBody";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";

class ViewSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      column: [{ name: "S.N." }, { name: "Sections" }, { name: "Actions" }],
    };
  }

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const {
      data,
      sectionData,
      handleSectionChange,
      handleSectionSubmit,
      handleEdit,
      handleDelete,
    } = this.props;
    const { rowsPerPage, page } = this.state;
    return (
      <TableContainer>
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%" }}>
            <ListItem divider>
              <div style={{ fontWeight: "bold", flexGrow: 1 }}>Class Name</div>
              <div>{data.className}</div>
            </ListItem>
            {data.faculty && (
              <ListItem divider>
                <div style={{ fontWeight: "bold", flexGrow: 1 }}>Faculty</div>
                <div>{data.faculty}</div>
              </ListItem>
            )}
          </div>
          <div style={{ width: "50%" }}>
            <ListItem divider>
              <div style={{ fontWeight: "bold", flexGrow: 1 }}>
                Number of Sections
              </div>
              <div>{data.section.length}</div>
            </ListItem>
            {data.group && (
              <ListItem divider>
                <div style={{ fontWeight: "bold", flexGrow: 1 }}>Group</div>
                <div>{data.group}</div>
              </ListItem>
            )}
          </div>
        </div>
        <Table>
          <CustomTableHead column={this.state.column} />
          {this.props.section.length !== 0 ? (
            <TableBody>
              {(rowsPerPage > 0
                ? this.props.section.slice(
                    rowsPerPage * page,
                    rowsPerPage * page + rowsPerPage
                  )
                : this.props.section
              ).map((section, index) => (
                <SectionBody
                  section={section}
                  key={index}
                  index={index}
                  sectionData={sectionData}
                  handleSectionChange={handleSectionChange}
                  handleSectionSubmit={handleSectionSubmit}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                />
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  Please enter data at left form
                </TableCell>
              </TableRow>
            </TableBody>
          )}
          {this.props.section.length !== 0 && (
            <CustomTableFooter
              count={this.props.section.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handlePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          )}
        </Table>
      </TableContainer>
    );
  }
}

export default ViewSection;
